import Styled from 'styled-components';
import {InputStyle} from './input.styled';

const fontSize = '18px';
export const ModalHeaderInputStyled = Styled(InputStyle)`
	text-align: left;
	box-sizing: border-box;
	border: 1px solid transparent;
	font-size: ${fontSize};
	position: relative;
	left: -16px;
	width: calc(100% + 32px);
	z-index: 1;
	padding: 0px 28px 0 16px;
	
	background-color: transparent;
	&:focus + span {
	    display: none;
	}
	
	::-webkit-input-placeholder {
		font-size: ${fontSize};
	}
	::-moz-placeholder {
		font-size: ${fontSize};
	}
	:-ms-input-placeholder {
		font-size: ${fontSize};
	}
	:-moz-placeholder {
		font-size: ${fontSize};
	}
	div {
        color: red;
	}
`;

export const TextMeasurer = Styled.span`
	font-size: ${fontSize};
	visibility: hidden;
	position: absolute;
	max-width: calc(100% - 16px);
`;

export const InputWrapper = Styled.div`
    position: relative;
    * + span {
        position: absolute;
        top: 0;
        height: 40px;
        left: ${props => props.textWidth + 8}px;
    }
`;

export const ErrorMessage = Styled.div`
    color: red;
    font-size: 13px;
`;
